// calendar.js

// /////////////////////////////////////////////////////////////////////////////
// lifeCycleMixin
// /////////////////////////////////////////////////////////////////////////////

/* eslint-disable-next-line no-unused-vars */
var lifeCycleMixin = {
  mounted() {
    this.fetchData();
  },
};

// /////////////////////////////////////////////////////////////////////////////
// lifeCycleMixin
// /////////////////////////////////////////////////////////////////////////////

var methodsMixin = {/* eslint-disable-line no-unused-vars */
  methods: {
    zeroPad(num, places) {
      var zero = places - num.toString().length + 1;
      return Array(+(zero > 0 && zero)).join('0') + num;
    },
    dateObjToString(date) {
      let y = date.getFullYear();
      let m = this.zeroPad(date.getMonth() +1, 2);
      let d = this.zeroPad(date.getDate(), 2);
      return `${y}-${m}-${d}`;
    },
    fetchData() {
      obj = {};
      obj.resource_id = this.resource_id;
      obj.start_date = this.dateObjToString(this.minDate);
      obj.end_date = this.dateObjToString(this.maxDate);
      /* eslint-disable-next-line max-len */
      let url = `/availibility/?resource_id=${obj.resource_id}&start_date=${obj.start_date}&end_date=${obj.end_date}`;
      axios({
        method: 'POST',
        url: url,
        data: {},
      }).then((response) => {
        // axios:ok
        if (response.data.length) {
          this.liveData = response.data;
        }
      }).catch((error) => {
        // axios:fatal
      });

      return;
    },
    xgetRangeDates(startDate, endDate) {
      let rangeDates = [];

      let addDays = function(days) {
        /* eslint-disable-next-line no-invalid-this */
        let date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
      };

      while (startDate <= endDate) {
        rangeDates.push(startDate);
        startDate = addDays.call(startDate, 1);
      }

      return rangeDates;
    },
    getFirsDateObjPlusMonths(plus) {
      let date = new Date();
      let y = date.getFullYear();
      let m = date.getMonth() + plus;
      let firstDateObj = new Date(y, m, 1);
      return firstDateObj;
    },
    getLastDateObjPlusMonths(plus) {
      let date = new Date();
      let y = date.getFullYear();
      let m = date.getMonth() + plus;
      let lastDateObj = new Date(y, m + 1, 0);
      return lastDateObj;
    },
  },
};

// /////////////////////////////////////////////////////////////////////////////
// computedMixin
// /////////////////////////////////////////////////////////////////////////////

var computedMixin = {/* eslint-disable-line no-unused-vars */
  computed: {
    attributes() {
      let Obj = this.liveData.map(d => ({
        key: `booking_id.${d.booking_id}`,
        highlight: {
          color: 'red',
          fillMode: 'solid',
        },
        dates: new Date(d.booking_date),
        customData: d,
      }));

      Obj.push(this.todayAttributes[0]);
      return Obj;
    },
  },
};

// /////////////////////////////////////////////////////////////////////////////
// dataMixin
// /////////////////////////////////////////////////////////////////////////////

var dataMixin = {/* eslint-disable-line no-unused-vars */
  data: function() {
    return {
      id: 'empty',
      minDate: new Date(),
      maxDate: new Date(this.getLastDateObjPlusMonths(12)),
      disabledDays: [],
      liveData: [],
      todayAttributes: [
        {
          key: 'today',
          dot: 'blue',
          dates: new Date(),
        },
      ],
      selectedDate: new Date(),
    };
  },
};

//
// EOF
//
